export const SECTION_TYPES = {
    PRESENTATION: 'SECTION_PRESENTATION',
    SETTINGS: 'SECTION_SETTINGS',
    USAGE: 'SECTION_USAGE',
    POWER_BATTERY: 'SECTION_POWER_BATTERY',
    END_LIMITS: 'SECTION_END_LIMITS',
    SPEED_ROTATION: 'SECTION_SPEED_ROTATION',
    STOP_OBSTACLE: 'SECTION_STOP_OBSTACLE',
    EQUIPMENTS: 'SECTION_EQUIPMENTS',
    OTHERS: 'SECTION_OTHERS',
} as const;

export type SectionType = (typeof SECTION_TYPES)[keyof typeof SECTION_TYPES];
